import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./style.css";
import { watchCompanyChanges } from "@/api/companyGuard";

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount("#app");
watchCompanyChanges();

// Re-create Lucide icons after each navigation so newly-rendered <i data-lucide>
// elements get replaced with the SVG.
router.afterEach(() => {
    // window.lucide is provided by the <script src="https://unpkg.com/lucide@latest"> tag in index.html
    queueMicrotask(() => {
        const lucide = (window as any).lucide;
        if (lucide && typeof lucide.createIcons === "function") {
            lucide.createIcons();
        }
    });
});
